/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateIncidentDTO = {
    status?: UpdateIncidentDTO.status;
    overriddenType?: string;
    overriddenRoadInformation?: string;
};
export namespace UpdateIncidentDTO {
    export enum status {
        NOT_REVIEWED = 'NOT_REVIEWED',
        START_ACTION = 'START_ACTION',
        SELF_ACTION = 'SELF_ACTION',
        KNOW_MESSAGE = 'KNOW_MESSAGE',
        NO_ACTION = 'NO_ACTION',
    }
}

